import { render, staticRenderFns } from "./WorkExperienceForm.vue?vue&type=template&id=baf04e94&"
import script from "./WorkExperienceForm.vue?vue&type=script&lang=js&"
export * from "./WorkExperienceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports